import { createFileRoute } from '@tanstack/react-router';

import { CreateVisitContainer } from '@/features/visits/containers/create';

export const Route = createFileRoute('/_layout/visits/create')({
  component: CreateVisitContainer,
});
